export default {
    'page': {
        component: import('@/components/integrations/protokol/payments/Index'),
        permissions: ['view_transactions']
    },

    'home': {
        component: import('@/components/integrations/protokol/payments/Home'),
        permissions: ['view_transactions']
    },

    'menu': {
        component: import('@/components/integrations/protokol/payments/Menu'),
        permissions: ['view_transactions']
    },

    'onboarding': {
        component: import('@/components/integrations/protokol/payments/Onboarding'),
    }
}